import { cx, Icon, type IconId } from '@amumin/ui-core';

import styles from './Input.module.css';

export interface InputProps {
  id?: string;
  name?: string;
  /** Datum en tijd: gebruik DateField / TimeField (DateTimeField.tsx). */
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'search' | 'url';
  value: string;
  onInput: (value: string) => void;
  placeholder?: string;
  /** Icoon links in het veld (bv. zoeken). */
  icon?: IconId;
  /** Toegankelijke naam als er geen zichtbaar <label> is. */
  label?: string;
  autoComplete?: string;
  inputMode?: 'text' | 'numeric' | 'decimal' | 'email' | 'tel' | 'search' | 'url';
  invalid?: boolean;
  describedBy?: string | undefined;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  min?: string | number;
  max?: string | number;
  step?: string | number;
  pattern?: string;
  size?: 'normal' | 'large';
}

/** Kaal invoerveld (zonder label); TextField gebruikt dezelfde stijl met label en hulptekst. */
export function Input({
  id,
  name,
  type = 'text',
  value,
  onInput,
  placeholder,
  icon,
  label,
  autoComplete,
  inputMode,
  invalid,
  describedBy,
  disabled,
  required,
  autoFocus,
  maxLength,
  min,
  max,
  step,
  pattern,
  size = 'normal',
}: InputProps) {
  return (
    <span class={cx(styles.wrap, icon && styles.withIcon, size === 'large' && styles.large)}>
      {icon ? <Icon id={icon} size={20} class={styles.icon} /> : null}
      <input
        id={id}
        name={name ?? id}
        class={styles.input}
        type={type}
        value={value}
        placeholder={placeholder}
        aria-label={label}
        autoComplete={autoComplete}
        inputMode={inputMode}
        aria-invalid={invalid ? 'true' : undefined}
        aria-describedby={describedBy}
        disabled={disabled}
        required={required}
        autoFocus={autoFocus}
        maxLength={maxLength}
        min={min}
        max={max}
        step={step}
        pattern={pattern}
        onInput={(e) => onInput((e.currentTarget as HTMLInputElement).value)}
      />
    </span>
  );
}
